import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "content absolute-fill" }
const _hoisted_4 = {
  key: 1,
  alt: "Scouts Best Choice",
  class: "medal",
  src: `/img/page/landing/registration/misc/bestChoice.png`
}

import TechnoFrame from "@/components/Common/TechnoFrame.vue";
import CardBackground from "@/components/RegistrationPage/Card/PcVersion/CardBackground.vue";
import CardInfo from "@/components/RegistrationPage/Card/PcVersion/CardInfo.vue";

import {defineComponent, PropType} from 'vue'
import store from "@/store";
import {PassProperties} from "@/components/RegistrationPage/Card/PassProperties";

const __default__ = defineComponent({
    name: 'PassCard',

    data(): {
        tilt: {
            x: number
            y: number
        },

        targetTilt: {
            x: number
            y: number
        },

        scale: number

        interval: number | null
    } {
        return {
            tilt: {
                x: 0,
                y: 0,
            },

            targetTilt: {
                x: 0,
                y: 0,
            },

            scale: 1.24,
            interval: null,
        }
    },

    props: {
        tiltAngle: {
            type: Number,
            default: 20,
        },

        pass: {
            type: Object as PropType<PassProperties>,
            required: true,
        },
    },

    methods: {
        onMouseMove(event: MouseEvent): void
        {
            if (this.pageWidth <= store.state.mobileVersionThresholdWidth) return

            const box = this.$refs.box
            if (box instanceof HTMLDivElement) {
                this.targetTilt.x = this.tiltAngle * ( 2 * event.offsetX / box.clientWidth - 1)
                this.targetTilt.y = - this.tiltAngle * ( 2 * event.offsetY / box.clientHeight - 1)
            }
        },

        onMouseLeave(): void
        {
            if (this.pageWidth <= store.state.mobileVersionThresholdWidth) return

            this.targetTilt.x = 0
            this.targetTilt.y = 0
        },

        onClick(): void
        {
            store.state.selectedPass = this.pass
        },

        createInterval(): void
        {
            this.scale = 1
            if (this.interval) {
                this.tilt.x = 0
                this.tilt.y = 0

                clearInterval(this.interval)
            }

            if (this.pageWidth <= store.state.mobileVersionThresholdWidth) return

            this.scale = 1.25
            this.interval = setInterval(() => {
                const deltaX = Math.abs(this.targetTilt.x - this.tilt.x)
                if (deltaX < 0.001) {
                    this.tilt.x = this.targetTilt.x
                } else {
                    this.tilt.x += (this.targetTilt.x - this.tilt.x) / 50
                }

                const deltaY = Math.abs(this.targetTilt.y - this.tilt.y)
                if (deltaY < 0.001) {
                    this.tilt.y = this.targetTilt.y
                } else {
                    this.tilt.y += (this.targetTilt.y - this.tilt.y) / 50
                }
            })
        },
    },

    mounted(): void
    {
        this.createInterval()
    },

    computed: {
        pageWidth(): number
        {
            return store.state.pageSize.width
        },
    },

    watch: {
        pageWidth: {
            handler(newValue, oldValue): void
            {
                if (
                    (newValue <= store.state.mobileVersionThresholdWidth && oldValue > store.state.mobileVersionThresholdWidth)
                    || (newValue > store.state.mobileVersionThresholdWidth && oldValue <= store.state.mobileVersionThresholdWidth)
                ) {
                    this.createInterval()
                }
            },
        },
    },
})


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

_useCssVars(_ctx => ({
  "0c5f8105": (_ctx.scale),
  "22c74e90": (`0 0 19px 17px ${_ctx.pass.glowColor}`)
}))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["passCard", {
            active: _ctx.pass === _unref(store).state.selectedPass,
            mobile: _unref(store).state.pageSize.width <= _unref(store).state.mobileVersionThresholdWidth,
        }]),
    onMousemove: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onMouseMove && _ctx.onMouseMove(...args))),
    onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeave && _ctx.onMouseLeave(...args))),
    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args))),
    ref: 'box',
    style: _normalizeStyle({
            transform: `perspective(1000px) rotateY(${_ctx.tilt.x}deg) rotateX(${_ctx.tilt.y}deg)`,
        })
  }, [
    _createVNode(TechnoFrame, {
      style: {"pointer-events":"none"},
      offset: 5,
      "size-modifier": 0.3
    }),
    _createElementVNode("img", {
      class: "face",
      alt: "",
      src: `/img/page/landing/registration/avatar/${_ctx.pass.avatar.image}/body.png`
    }, null, 8, _hoisted_1),
    (_ctx.pass.secondaryBackground !== null)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "secondaryBackground",
          alt: "",
          src: `/img/page/landing/registration/misc/${_ctx.pass.secondaryBackground}`
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(CardBackground, {
        tilt: _ctx.tilt,
        "tilt-angle": _ctx.tiltAngle,
        pass: _ctx.pass,
        "bg-url": `${_ctx.pass.background}.webp`
      }, null, 8, ["tilt", "tilt-angle", "pass", "bg-url"]),
      _createVNode(CardInfo, { pass: _ctx.pass }, null, 8, ["pass"])
    ]),
    (_ctx.pass.isPlayersChoice)
      ? (_openBlock(), _createElementBlock("img", _hoisted_4))
      : _createCommentVNode("", true)
  ], 38))
}
}

})